var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOnlyDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 61,
    viewBox: "0 0 70 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-43 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    transform: "translate(43 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M56.688,60.6H44.349l0-.01L38.175,47.4,28.342,26.379l-16,34.221H0l3.468-7.413,18.7-40L28.342,0h0l6.17,13.187,9.833,21.024L50.514,47.4l2.706,5.784Z",
    fill: "#105157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M117.763,83.7H105.424l-3.468-7.413L99.25,70.5,93.08,57.312,99.25,44.12l6.17,13.192,3.011,6.441Z",
    transform: "translate(-48.736 -23.101)",
    fill: "#4cbb7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M79.519,112.687l0,.01H67.18l6.17-13.2Z",
    transform: "translate(-35.175 -52.097)",
    fill: "#4cbb7f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyDark);
export default __webpack_public_path__ + "static/media/logo-only-dark.0139036339590ad8c7412ff217845917.svg";
export { ForwardRef as ReactComponent };